<template>
  <div>
    <div class="text-center mb-2">
      <el-radio-group v-model="field.is_global_variable" >
        <el-radio-button :label="false">Custom Field</el-radio-button>
        <el-radio-button :label="true">Global Variable</el-radio-button>
      </el-radio-group>
    </div>

    <el-form label-position="right" v-if="!field.is_global_variable">
      <title-and-description :field="field" />
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <el-row :gutter="50">
        <el-col :span="12">
          <div class="form-group">
            <el-form-item label="No of Rows Required?">   
              <span class="red-asterisk">*</span>
                 
              <el-input
              type="number"
              maxlength="50"
              min="3"
              resize="none"
              @change="checkMaxMinLen"
              v-model="field.validations.rows"
              placeholder="Enter Number Of Rows"
            ></el-input>
            <p v-if="maxMinErr" style="color:red; font-size: 14px;">{{ maxMinErrMsg }}</p>
              <!-- <el-select v-model="field.validations.rows" placeholder="Select rows">
                <el-option v-for="item in rowsOptions" :key="item" :label="item" :value="item"></el-option>
              </el-select> -->
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <field-attributes :field="field" />
        </el-col>
        <el-col :span="12">
          <is-field-required :field="field" class="field-required"/>
        </el-col>
        <el-col :span="10">
        <div class="icon-dropdown-selection">
            <el-button type="text" @click="iconPickerdialogVisible = true">
              <div class="d-flex align-center menu-icon">
                <span>
                  <icons :iconName="templateIconPath"></icons>
                </span>
                <i class="el-icon-circle-plus"></i>
              </div>
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-form label-position="right" v-if="field.is_global_variable">
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <div class="form-group">
          
            <el-form-item label="Global Variable">
              <el-select v-model="field.global_variable_id" @change="setGlobalVariable">
                <el-option
                  v-for="(globalVariable,index) of allGlobalVariables"
                  :key="index"
                  :label="globalVariable.label"
                  filterable
                  :value="globalVariable._id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="30">
        <el-col :span="12">
          <placeholder :field="field" />
        </el-col>
        <el-col :span="12">
          <field-filled-by :field="field" />
        </el-col>
      </el-row>
      <is-field-required :field="field" class="field-required"/>
    </el-form>
    <dialog-component
      :title="'Select An Icon'"
      :visible="iconPickerdialogVisible"
      :containerWidth="getIsMobile ? '100%' : '77%'"
      @before-close="closeSelectIcon"
      :isShowFooter="false"
      :selectedIcon="field.icon_name"
    >
      <div class="icons-component">
        <div class="iconslistScrollable">
          <icons-list @icon-data="getIconPath"></icons-list>
        </div>
      </div>
    </dialog-component>
  </div>
</template>

<script>
// import TitleAndDescription from "./TitleAndDescription";
// import IsFieldRequired from "./IsFieldRequired";
// import FieldFilledBy from "./FieldFilledBy";
// import Placeholder from "./Placeholder";
// import FieldAttributes from "./FieldAttributes";
import { fetchGlobalVariables } from "@/repo/globalVariables"
import { mapGetters } from "vuex";
export default {
  name:"templates-formComponents-MultiLineText",
  components: {
    "TitleAndDescription":()=>import("./TitleAndDescription"),
    "IsFieldRequired":()=>import("./IsFieldRequired"),
    "FieldFilledBy":()=>import("./FieldFilledBy"),
    "Placeholder":()=>import("./Placeholder"),
    "FieldAttributes":()=>import("./FieldAttributes")
  },
  props: ["field"],
  computed: {
  //  ...mapGetters("globalVariables", ["getAllGlobalVariables"]),
  ...mapGetters("navigationOpen", ["getIsMobile", "getIsRSOpen"]),
    allGlobalVariables() {
      return this.getAllGlobalVariables
        ? this.getAllGlobalVariables.data || []
        : [];
    },
  },
  mounted() {
    this.fetchGlobalVaribales();
    if (this.field && this.field.icon_name) {
      this.templateIconPath = this.field.icon_name;
    }
  },
  data() {
    return {
      rowsOptions: [1, 2, 3, 4 ,5],
      maxMinErrMsg: '',
      maxMinErr:false,
      iconPickerdialogVisible: false,
      getAllGlobalVariables: null,
      templateIconPath: '',
    };
    
  },
  methods: {
    closeSelectIcon() {
      this.iconPickerdialogVisible = false;
    },
    getIconPath(icon) {
      this.templateIconPath = icon;
      this.$set(this.field, 'icon_name', icon);
      this.iconPickerdialogVisible = false;
    },
    checkMaxMinLen(){
      if(this.field.validations && this.field.validations.rows){
          const maxlength =this.field.validations.rows;
            if( maxlength< 3){
              this.field.validations.rows=3;
              this.maxMinErrMsg = 'Number Rows value should not less than 3';
              this.maxMinErr = true;
            }else{
              this.maxMinErr = false;
            }
      }
     },
    async fetchGlobalVaribales() {
     
      let params = {
        get_all: true,
        input_type: this.field.input_type
      };
      this.getAllGlobalVariables = await fetchGlobalVariables(params);
    },
    setGlobalVariable() {
      let globalVariable = this.allGlobalVariables.find(
        x => x._id == this.field.global_variable_id
      );
      this.field.label = globalVariable.label;
      this.field.description = globalVariable.description;
      this.field.validations.rows = globalVariable.rows;
    }
  }
};
</script>

<style lang="scss" scoped>
.red-asterisk {
  position: relative;
  right: 10px;
  bottom: 2px;
}
</style>